'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdConfirmationNumber = function MdConfirmationNumber(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 14.1v-3.2h-3.2v3.2h3.2z m0 7.5v-3.2h-3.2v3.2h3.2z m0 7.5v-3.2h-3.2v3.2h3.2z m15-12.5c-1.8 0-3.2 1.6-3.2 3.4s1.4 3.4 3.2 3.4v6.6c0 1.8-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.6-3.2-3.4v-6.6c1.8 0 3.2-1.6 3.2-3.4s-1.4-3.4-3.2-3.4v-6.6c0-1.9 1.4-3.4 3.2-3.4h26.8c1.8 0 3.2 1.5 3.2 3.4v6.6z' })
        )
    );
};

exports.default = MdConfirmationNumber;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/confirmation-number.js
// module id = 607
// module chunks = 0